module.exports = __webpack_public_path__ + "img/blog-single.196b9f44.jpg";